import { PropsWithChildren } from 'react';
import { StyleProp, StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native';

import { Radius, Spacing } from '@/constants/theme';
import { useTheme } from '@/hooks/use-theme';

export type BadgeVariant =
  | 'default'
  | 'gold'
  | 'destructive'
  | 'chart4'
  | 'primary'
  | 'outline';

export type BadgeProps = PropsWithChildren<{
  variant?: BadgeVariant;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}>;

export function Badge({ variant = 'default', style, textStyle, children }: BadgeProps) {
  const theme = useTheme();

  let background: string = theme.primary;
  let color: string = theme.primaryForeground;
  let borderColor: string = 'transparent';

  switch (variant) {
    case 'gold':
      background = theme.gold;
      color = theme.goldForeground;
      break;
    case 'destructive':
      background = theme.destructive;
      color = '#fff';
      break;
    case 'chart4':
      background = theme.chart4;
      color = '#fff';
      break;
    case 'primary':
      background = theme.primary;
      color = theme.primaryForeground;
      break;
    case 'outline':
      background = 'transparent';
      color = theme.text;
      borderColor = theme.border;
      break;
    default:
      background = theme.primary;
      color = theme.primaryForeground;
  }

  return (
    <View style={[styles.badge, { backgroundColor: background, borderColor }, style]}>
      <Text style={[styles.text, { color }, textStyle]}>{children}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: Spacing.two,
    paddingVertical: 4,
    borderRadius: Radius.sm,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
  text: {
    fontSize: 11,
    fontWeight: '600',
  },
});
